<template>
     <div
            class="header-container-mobile"
            :class="{'is-black' : color && color.isblack, 'is-fixed': color && color.isfixed, 'is-open': color && color.isopen,  '-active': show}"
        >
            <div class="logo-mobile">
                <div class="elements" >
                    <span class="text" @click="showOriginal = !showOriginal" >{{ $t("header.tooltip.title") }}
                        <i class="ox-menu-arrow" :class="{'active' : showOriginal}"></i>
                    </span>
                    <ul class="list" v-if="showOriginal">
                        <li
                            class=""
                            v-for="(original, index) in originals"
                            :key="index"
                        >
                            <a :href="original.url" class="header-link">{{
                                original.text
                            }}</a>
                        </li>
                    </ul>
                </div>
                <div class="background">
                    <div class="lang"><languages-selector /></div>
                    <svg class="icon icon-cross" @click="showMenu">
                        <use xlink:href="#icon-cross"></use>
                    </svg>
                </div>
            </div>
            <div class="dus-container">
                <ul class="header-list mt-24 mb-40 ">
                    <template v-for="item in list">
                        <li class="header-item"  v-if="item.isLink && !item.isService &&  !item.isNews">
                            <a
                               
                                :href="item.url"
                                :target="item.target"
                                ><p>{{ item.text }}</p>
                            </a>
                        </li>
                        <li
                            v-if="!item.isLink && item.isService"
                            @click="serviceActive = !serviceActive"
                        >
                            <div class="header-item">
                                <div :class="serviceActive ? 'active' : ''">
                                    <p>{{ item.text }}</p>
                                </div>
                                <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[ serviceActive ? 'active' : '','chevron',]">
                                    <path d="M1 1L7 7L13 1" stroke="black" stroke-width="2"/>
                                </svg>
                            </div>

                            <div
                                class="megamenu-wrapper-mobile mobile"
                                :class="serviceActive ? 'active' : ''"
                            >
                                <div v-for="(service, index) in services">
                                    <div class="subtitle my-24">
                                        {{ service.text }}
                                    </div>
                                    <div class="links">
                                        <a
                                        class="link"
                                        v-for="item in service.list"
                                            :href="item.url"
                                            :target="item.target"
                                        >
                                            {{ item.text }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </template>
                </ul>

                <ul class="social">
                    <li>
                        <a
                            href="https://theoriginals.renault.com/go/facebook"
                            target="_blank"
                            >{{ $t("header.facebook") }}</a
                        >
                    </li>
                    <li>
                        <a
                            href="https://theoriginals.renault.com/go/instagram"
                            target="_blank"
                            >{{ $t("header.instagram") }}
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://theoriginals.renault.com/go/linkedin"
                            target="_blank"
                            >{{ $t("header.linkedin") }}
                        </a>
                    </li>
                </ul>
                <ul class="legal">
                    <li>
                        <a href="/faq">{{ $t("header.contact") }}</a>
                    </li>
                    <li>
                        <a href="/legal-mention">{{ $t("header.legal") }}</a>
                    </li>
                </ul>
            </div>
        </div>
</template>

<script>
import LanguagesSelector from "./LanguagesSelector.vue";
    export default {
        components: {
            LanguagesSelector,
        },
        props: {
            show: {
               type: Boolean,
               default: false
            },
            originals: {
                type: [Array, Object],
                default: null,
            },
            list: {
                type: [Array, Object],
                default: null,
            },
            services: {
                type: [Array, Object],
                default: null,
            },
            color: {
                type: [Array, Object],
                required: false,
                default: null
            }       
        },
        data() {
            return {
                serviceActive: false,
                showOriginal: false
            }
        },
        methods: {
            showMenu() {
                this.$emit('close')
            }
        },
    }
</script>
